<template>
  <div class="contianer">
    <n-page-header class="subheader">
      <template #title>
        <n-space
          style="
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-start;
            margin-top: 0px;
            margin-bottom: 0px;
            vertical-align: top;
          "
        >
          <iframe
            src="https://giphy.com/embed/gy4nYqDpBTXP9SYnRm"
            width="140"
            height="50"
            frameBorder="0"
            class="giphy-embed"
          ></iframe>
          <n-h1 style="margin-top: 2px">วันที่ {{ DateText }}</n-h1>
          <router-link :to="{ name: 'SildeView' }">
            <n-button quaternary circle type="primary">
              <template #icon>
                <n-icon :size="18">
                  <InformationCircleOutline />
                </n-icon>
              </template>
            </n-button>
          </router-link>
        </n-space>
      </template>
      <template #extra>
        <n-space vertical style="margin-top: 5px">
          <Clock></Clock>
          <n-button @click="openModal" v-if="Lockmode == 'Unlock'">
            เพิ่มกำหนดการ
          </n-button>
          <n-space style="margin: 0 20px">
            <n-icon :size="18" @click="prevDay">
              <ArrowBack />
            </n-icon>
            <n-icon :size="18" @click="currentDayBack">
              <Home />
            </n-icon>
            <n-icon :size="18" @click="nextDay">
              <ArrowForward />
            </n-icon>
          </n-space>
        </n-space>
      </template>
    </n-page-header>
    <n-modal v-model:show="showModal">
      <n-card
        style="width: 600px"
        title="วาระผู้บริหาร"
        :bordered="false"
        size="huge"
        role="dialog"
        aria-modal="true"
      >
        <template #default>
          <n-space vertical>
            <n-form
              ref="formRef"
              label-width="auto"
              :model="newSchedule"
              size="small"
            >
              <n-grid :x-gap="12" :y-gap="8" :cols="1">
                <n-grid-item>
                  <n-form-item label="ผู้บริหาร" path="user.name">
                    <n-select
                      status="warning"
                      v-model:value="newSchedule.board"
                      :options="Board"
                    />
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="3">
                <n-grid-item>
                  <n-form-item
                    label="ระยะเวลา"
                    path="newSchedule.enddate"
                  >
                    <n-switch
                      :rail-style="railStyle"
                      v-model:value="longday"
                    >
                      <template #checked> หลายวัน </template>
                      <template #unchecked> วันเดียว </template>
                    </n-switch>
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="2">
                <n-grid-item>
                  <n-form-item
                    label="วันที่เริ่ม"
                    path="newSchedule.strdate"
                  >
                    <n-date-picker
                      status="warning"
                      v-model:formatted-value="newSchedule.strdate"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </n-form-item>
                </n-grid-item>
                <n-grid-item v-if="longday">
                  <n-form-item
                    label="วันสิ้นสุด"
                    path="newSchedule.enddate"
                  >
                    <n-date-picker
                      v-model:formatted-value="newSchedule.enddate"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="2">
                <n-grid-item>
                  <n-form-item
                    label="เวลาเริ่ม"
                    path="newSchedule.strtime"
                  >
                    <n-time-picker
                      v-model:formatted-value="newSchedule.strtime"
                      format="HH:mm"
                    />
                  </n-form-item>
                </n-grid-item>
                <n-grid-item v-if="endtime">
                  <n-form-item
                    label="เวลาสิ้นสุด"
                    path="newSchedule.endtime"
                  >
                    <n-time-picker
                      v-model:formatted-value="newSchedule.endtime"
                      format="HH:mm"
                    />
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="1">
                <n-grid-item>
                  <n-form-item
                    label="วาระงาน"
                    path="newSchedule.description"
                  >
                    <n-input
                      status="warning"
                      v-model:value="newSchedule.description"
                      type="textarea"
                      placeholder="เพิ่มวาระ"
                    />
                  </n-form-item>
                </n-grid-item>
                <n-gi :span="24">
                  <div
                    style="display: flex; justify-content: flex-end"
                  >
                    <n-space>
                      <n-button type="primary" @click="SaveSchedule">
                        บันทึก
                      </n-button>
                      <n-button
                        type="error"
                        @click="closeModal('add')"
                      >
                        ยกเลิก
                      </n-button>
                    </n-space>
                  </div>
                </n-gi>
              </n-grid>
            </n-form>
          </n-space>
        </template>
      </n-card>
    </n-modal>

    <n-data-table
      remote
      ref="table"
      size="large"
      :loading="isLoad"
      :columns="columns"
      :single-line="false"
      :data="daySchedule"
      :row-props="rowProps"
    />
    <n-grid :x-gap="12" :cols="2">
      <n-gi>
        <n-space justify="start" style="margin-top: 2px">
          <n-button
            type="info"
            @click="openPrintfilter"
            v-if="mode && pinVerify"
          >
            พิมพ์
          </n-button>
        </n-space>
      </n-gi>
      <n-gi>
        <n-space justify="end" style="margin-top: 2px">
          <n-tag
            type="error"
            v-model:checked="modeDelete"
            checkable
            v-if="mode && pinVerify"
          >
            ลบข้อมูล
          </n-tag>
          <n-tag v-model:checked="mode" checkable>
            {{ Lockmode == 'Lock' ? 'Unlock' : 'Lock' }}
          </n-tag>
        </n-space>
      </n-gi>
    </n-grid>
    <n-modal v-model:show="showModal2">
      <n-card
        style="width: 400px"
        title="Admin Mode Locked"
        :bordered="false"
        size="huge"
        role="dialog"
        aria-modal="true"
      >
        <n-space>
          <div style="display: flex; flex-direction: row">
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              separator="-"
              :num-inputs="4"
              :should-auto-focus="true"
              :is-input-num="true"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
          </div>
        </n-space>
      </n-card>
    </n-modal>
    <n-modal v-model:show="showPrintModal">
      <n-card
        style="width: 600px"
        title="ตัวเลือกการพิมพ์"
        :bordered="false"
        size="huge"
        role="dialog"
        aria-modal="true"
      >
        <template #default>
          <n-space vertical>
            <n-form
              ref="formRef"
              label-width="auto"
              :model="newSchedule"
              size="small"
            >
              <n-grid :x-gap="12" :y-gap="8" :cols="3">
                <n-grid-item>
                  <n-form-item
                    label="ระยะเวลา"
                    path="Printfilter.enddate"
                  >
                    <n-switch
                      :rail-style="railStyle"
                      v-model:value="longday"
                      loading
                    >
                      <template #checked> หลายวัน </template>
                      <template #unchecked> วันเดียว </template>
                    </n-switch>
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="2">
                <n-grid-item>
                  <n-form-item
                    label="วันที่เริ่ม"
                    path="Printfilter.strdate"
                  >
                    <n-date-picker
                      status="warning"
                      v-model:formatted-value="Printfilter.strdate"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </n-form-item>
                </n-grid-item>
                <n-grid-item v-if="longday">
                  <n-form-item
                    label="วันสิ้นสุด"
                    path="Printfilter.enddate"
                  >
                    <n-date-picker
                      v-model:formatted-value="Printfilter.enddate"
                      value-format="yyyy-MM-dd"
                      type="date"
                    />
                  </n-form-item>
                </n-grid-item>
              </n-grid>
              <n-grid :x-gap="12" :y-gap="8" :cols="1">
                <n-gi :span="24">
                  <div
                    style="display: flex; justify-content: flex-end"
                  >
                    <n-space>
                      <n-button type="primary" @click="genReport">
                        พิมพ์
                      </n-button>
                      <n-button
                        type="error"
                        @click="closeModal('print')"
                      >
                        ยกเลิก
                      </n-button>
                    </n-space>
                  </div>
                </n-gi>
              </n-grid>
            </n-form>
          </n-space>
        </template>
      </n-card>
    </n-modal>
  </div>
</template>
<script>
import { defineComponent, inject } from 'vue';
import { onMounted, ref, computed, onUnmounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useMessage, useDialog } from 'naive-ui';
import { DataServices } from '../services/DataServices';
import { daySchedulerReport } from '../report/daySchedulerReport';
import { FirebaseDataService } from '../services/FirebaseDataServices';
import Clock from '../components/ClockVue.vue';
import {
  ArrowBack,
  ArrowForward,
  Home,
  InformationCircleOutline,
} from '@vicons/ionicons5';
import VOtpInput from 'vue3-otp-input';
export default defineComponent({
  name: 'DaySchedule',
  components: {
    Clock,
    ArrowBack,
    ArrowForward,
    Home,
    InformationCircleOutline,
    VOtpInput,
  },
  setup() {
    const message = useMessage();
    const dialog = useDialog();
    const dayJS = inject('dayJS');
    const store = useStore();
    const time = new Date();
    const otpInput = ref(null);
    const mode = ref(false);
    const pinVerify = ref(false);
    const Lockmode = ref('Lock');
    const modeDelete = ref(false);
    const longday = ref(false);
    const endtime = ref(true);
    const showModal = ref(false);
    const showModal2 = ref(false);
    const showPrintModal = ref(false);
    const Board = ref([]);
    const deletewidth = ref(2);
    const CurrentDatePage = ref(dayJS().format('YYYY-MM-DD'));
    const DateText = ref(DataServices.ConvertDateToThai('now'));
    const newSchedule = ref({
      board: '',
      strdate: null,
      enddate: null,
      strtime: null,
      endtime: null,
      description: '',
    });
    const Printfilter = ref({
      strdate: null,
      enddate: null,
    });
    const daySchedule = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.daySchedule)),
      ),
    );
    const onceDaySchedulePrint = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.onceDaySchedulePrint)),
      ),
    );
    const isLoad = ref(
      computed(() => JSON.parse(JSON.stringify(store.state.isLoad))),
    );
    const columns = createColumns();

    onMounted(async () => {
      await store.dispatch('dayScheduleLoad').then(() => {});
      FirebaseDataService.realtimeAwait();
    });
    onUnmounted(() => {
      //console.log('Unmounted!');
      FirebaseDataService.StopRealtimeAwait();
    });

    watch(mode, (nextmode, preMode) => {
      if (preMode == false) {
        showModal2.value = true;
      } else {
        modeDelete.value = false;
        Lockmode.value = 'Lock';
        pinVerify.value = false;
      }
    });
    watch(modeDelete, (nextmodeDelete, preModeDelete) => {
      if (preModeDelete == false) {
        modeDelete.value = true;
      } else {
        modeDelete.value = false;
      }
    });

    const handleOnComplete = (value) => {
      //console.log(value);
      if (value == '8988') {
        mode.value = true;
        Lockmode.value = 'Unlock';
        showModal2.value = false;
        pinVerify.value = true;
      } else {
        let x1Interval = setInterval(function () {
          otpInput.value.clearInput();
          clearInterval(x1Interval);
        }, 1000);
        message.error('Unlock Code Incorrect', { duration: 2e3 });
      }
    };

    // eslint-disable-next-line no-unused-vars
    const handleOnChange = (value) => {
      //console.log('OTP changed: ', value);
    };

    const clearInput = () => {
      otpInput.value.clearInput();
    };
    function createColumns() {
      return [
        {
          title: 'ผู้บริหาร',
          key: 'board',
          width: 110,
          rowSpan: (rowData, rowIndex) =>
            rowIndex === rowData.rowIndex ? rowData.desLength : 1,
        },
        {
          title: 'เวลา',
          key: 'time',
          width: 70,
        },
        {
          title: 'วาระงาน',
          key: 'description',
          render(row) {
            return row.description;
          },
        },
      ];
    }
    function railStyle({ focused, checked }) {
      const style = {};
      if (checked) {
        style.background = '#d03050';
        if (focused) {
          style.boxShadow = '0 0 0 2px #d0305040';
        }
      } else {
        style.background = '#2080f0';
        if (focused) {
          style.boxShadow = '0 0 0 2px #2080f040';
        }
      }
      return style;
    }
    async function openModal() {
      Board.value = await DataServices.getBoardAndRestructure();
      showModal.value = true;
    }
    async function closeModal(m) {
      if (m == 'add') {
        showModal.value = false;
        resetCreateField();
      } else {
        showPrintModal.value = false;
        resetPrintFilterField();
      }
    }
    function Changemode() {
      if (mode.value == false) {
        //mode.value = true;
        Lockmode.value = 'Unlock';
      } else {
        mode.value = false;
        modeDelete.value = false;
        Lockmode.value = 'Lock';
      }
    }
    function Deletemode() {
      //console.log(modeDelete.value);
      if (modeDelete.value == false) {
        modeDelete.value = true;
      } else {
        modeDelete.value = false;
      }
    }

    function SaveSchedule() {
      if (
        newSchedule.value.board == '' ||
        newSchedule.value.strdate == '' ||
        newSchedule.value.description == ''
      ) {
        message.info('กรุณากรอกข้อมูลให้ครบถ้วน', { duration: 3e3 });
      } else {
        FirebaseDataService.create(newSchedule.value)
          .then(() => {
            //console.log('Created new item successfully!');
            showModal.value = false;
            resetCreateField();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
    function DeleteSchedule(key) {
      FirebaseDataService.delete(key);
    }
    function rowProps(row) {
      if (row.key == '' || modeDelete.value == false) {
        //
      } else {
        return {
          style: 'cursor: pointer;',
          onClick: () => {
            dialog.warning({
              title: 'ลบข้อมูล',
              content: 'ยืนยันการลบข้อมูล',
              positiveText: 'ตกลง',
              negativeText: 'ยกเลิก',
              onPositiveClick: () => {
                DeleteSchedule(row.key);
                message.success('ลบข้อมูลสำเร็จ');
              },
              onNegativeClick: () => {},
            });
          },
        };
      }
    }
    async function prevDay() {
      let p = dayJS(CurrentDatePage.value).subtract(1, 'day');
      CurrentDatePage.value = p;
      await store
        .dispatch('dayScheduleLoadSpacificDay', CurrentDatePage.value)
        .then(() => {});
      DateText.value = DataServices.ConvertDateToThai(
        'fix',
        CurrentDatePage.value,
      );
    }
    async function nextDay() {
      let p = dayJS(CurrentDatePage.value).add(1, 'day');
      CurrentDatePage.value = p;
      await store
        .dispatch('dayScheduleLoadSpacificDay', CurrentDatePage.value)
        .then(() => {});
      DateText.value = DataServices.ConvertDateToThai(
        'fix',
        CurrentDatePage.value,
      );
    }
    async function currentDayBack() {
      let p = dayJS();
      CurrentDatePage.value = p;
      await store.dispatch('dayScheduleLoad').then(() => {});
      DateText.value = DataServices.ConvertDateToThai(
        'fix',
        CurrentDatePage.value,
      );
    }
    function openPrintfilter() {
      showPrintModal.value = true;
    }
    async function genReport() {
      if (Printfilter.value.strdate == null) {
        //
      } else {
        await store
          .dispatch(
            'onceDaySchedulePrintLoad',
            Printfilter.value.strdate,
          )
          .then(() => {});
        await daySchedulerReport.ReportExport(
          onceDaySchedulePrint.value,
          DataServices.ConvertDateToThai(
            'fix',
            Printfilter.value.strdate,
          ),
        );
      }
    }
    function resetCreateField() {
      newSchedule.value.board = '';
      newSchedule.value.strdate = null;
      newSchedule.value.enddate = null;
      newSchedule.value.strtime = null;
      newSchedule.value.endtime = null;
      newSchedule.value.description = '';
      longday.value = false;
    }
    function resetPrintFilterField() {
      Printfilter.value.strdate = null;
      Printfilter.value.enddate = null;
      longday.value = false;
    }
    return {
      dayJS,
      mode,
      Lockmode,
      DateText,
      columns,
      time,
      longday,
      endtime,
      daySchedule,
      onceDaySchedulePrint,
      isLoad,
      showModal,
      showModal2,
      showPrintModal,
      Board,
      deletewidth,
      modeDelete,
      newSchedule,
      CurrentDatePage,
      createColumns,
      railStyle,
      openModal,
      closeModal,
      SaveSchedule,
      DeleteSchedule,
      Changemode,
      Deletemode,
      prevDay,
      nextDay,
      currentDayBack,
      resetCreateField,
      rowProps,
      handleOnComplete,
      handleOnChange,
      clearInput,
      otpInput,
      pinVerify,
      openPrintfilter,
      Printfilter,
      genReport,
    };
  },
});
</script>
<style>
.n-data-table .n-data-table-tr {
  font-size: 15px;
  --n-merged-border-color: black;
}
.n-data-table .n-data-table-wrapper {
  --n-merged-border-color: black;
}
.n-form-item .n-form-item-blank {
  display: block;
}
.n-data-table:not(.n-data-table--single-line)
  .n-data-table-td.n-data-table-td--last-col {
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  word-break: break-word;
}
.n-card > .n-card__content:first-child,
.n-card > .n-card__footer:first-child {
  padding-top: var(--n-padding-bottom);
  padding: 9px;
}
element.style {
  padding: 11px;
}

.word-wrap {
  word-wrap: break-word;
}
.cut-text-multi {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.subheader {
  align-items: start;
  margin-top: -2px;
}
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
</style>
